(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('.polomi-lux-footer__newsletter-form form').forEach((form) => {
      if (form.dataset.polomiValidation === 'true') return;
      form.dataset.polomiValidation = 'true';
      form.noValidate = true;

      const input = form.querySelector('input[type="email"]');
      const wrapper = input?.closest('.polomi-newsletter-input');
      const error = wrapper?.querySelector('.polomi-newsletter-input__error');
      if (!input || !wrapper || !error) return;

      if (error.textContent.trim()) wrapper.classList.add('has-error');

      const clearError = () => {
        wrapper.classList.remove('has-error');
        error.classList.remove('is-visible');
        error.textContent = '';
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      };

      const showError = (message) => {
        error.textContent = message;
        error.classList.add('is-visible');
        wrapper.classList.add('has-error');
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', error.id);
        input.focus();
      };

      input.addEventListener('input', clearError);
      form.addEventListener('submit', (event) => {
        const value = input.value.trim();
        if (!value) {
          event.preventDefault();
          showError("Email can't be blank.");
        } else if (!input.validity.valid) {
          event.preventDefault();
          showError('Enter a valid email address.');
        }
      });
    });
  };

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
